export const DATE_FORMAT_SHORTYEAR = 'dd.MM.yy'
export const DATE_FORMAT_LONGYEAR = 'dd.MM.yyyy'
export const DATETIME_FORMAT_SECONDS = 'dd.MM.yyyy HH:mm:ss'
export const DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX"
